var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        fluid: "",
        "grid-list-xl": "",
        role: "search",
        "aria-label": "Search Section",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "", "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            {
              class: {
                "xs12 sm12 md12 lg12": _vm.$vuetify.breakpoint.mdAndDown,
                "xs10 sm10 md10 lg10": _vm.$vuetify.breakpoint.lgAndUp,
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md12: "",
                        lg12: "",
                        "align-center": "",
                        "text-center": "",
                        "justify-center": "",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.charactersList,
                          "item-text": "name",
                          "item-value": "char_oid",
                          color: "accent",
                          "prepend-icon": "fad fa-helmet-battle",
                          label:
                            _vm.$t("components.selectUserChar.form.receiver") +
                            " *",
                          name: "character-select",
                          "aria-label": _vm.$t(
                            "components.selectUserChar.form.receiver"
                          ),
                          "aria-required": "true",
                          "aria-invalid": !_vm.selectedChar,
                          autocomplete: "off",
                        },
                        on: { input: _vm.selectChar },
                      }),
                      _vm._v(" "),
                      _c("v-progress-linear", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoading,
                            expression: "isLoading",
                          },
                        ],
                        attrs: {
                          color: "accent",
                          indeterminate: "",
                          "aria-label": "Loading characters",
                          "aria-live": "polite",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }